import { useCallback, useEffect, useState } from "react";
import {
  getFireflyVisualIntensity,
  setFireflyVisualIntensity as persistFireflyVisualIntensity,
  subscribeFireflyVisualIntensity,
  type FireflyVisualIntensity,
} from "@/lib/firefly/fireflyVisualIntensity";

export type UseFireflyVisualIntensityResult = {
  intensity: FireflyVisualIntensity;
  setIntensity: (next: FireflyVisualIntensity) => void;
};

export function useFireflyVisualIntensity(): UseFireflyVisualIntensityResult {
  const [intensity, setIntensityState] = useState<FireflyVisualIntensity>(
    getFireflyVisualIntensity,
  );

  useEffect(() => {
    const unsubscribe = subscribeFireflyVisualIntensity(setIntensityState);
    setIntensityState(getFireflyVisualIntensity());
    return unsubscribe;
  }, []);

  const setIntensity = useCallback((next: FireflyVisualIntensity) => {
    persistFireflyVisualIntensity(next);
  }, []);

  return { intensity, setIntensity };
}
